/**
 * Images uploaded to the club's own storage (R2), for article covers and
 * article bodies. Pasting an external https link still works; this is an
 * addition, not a replacement.
 */
/** Where uploaded images are served from. Public, read-only, bytes only. */
export const MEDIA_PATH_PREFIX = '/api/public/media/';
/** Content-addressed: img/<sha256 prefix>.<ext>. The only key shape ever served. */
export const MEDIA_KEY_PATTERN = /^img\/[0-9a-f]{32}\.(?:webp|jpg|png|gif)$/;
/** Decoded size limit. The client downsizes before sending, so this is a backstop. */
export const MEDIA_MAX_BYTES = 5 * 1024 * 1024;
export const mediaUrl = (key) => `${MEDIA_PATH_PREFIX}${key}`;
//# sourceMappingURL=media.js.map